<template>
    <div class="giftcard-card-section">
        <form class="vue-form giftcard-details-form" :method="'POST'" @submit.prevent="submitPostalCode">
            <div class="vue-form-row" v-if="cardHolderName">
                 <vue-input :element="cardHolderName" :key="cardHolderName.id" @input="($event) => updateFieldValue(cardHolderName.id, $event.target.value)" />
            </div>
            <div class="vue-form-row">
                 <vue-input :element="cardNumberField" :key="cardNumberField.id" @input="updateFieldValue(cardNumberField.id, $event.target.value)" />
            </div>

            <div class="vue-form-row has-multiple-elements">
                <div class="vue-form-element">
                    <vue-input :element="pinField" :key="pinField.id" @input="updateFieldValue(pinField.id, $event.target.value)" />
                </div>
                <div class="vue-form-element">
                    <label>
                        <span class="field-label">{{resources.giftcards.cardBalance}}</span>
                    </label>
                    <div class="giftcard-balance">
                        <div class="giftcard-amount">
                            <span v-if="giftCardBalanceAmount">{{giftCardBalanceAmount}}</span>
                            <span v-else>-</span>
                        </div>
                        <button type="button" class="giftcard-button" @click="submit('checkBalance')">
                            <span class="giftcard-text">{{ resources.giftcards.checkBalance }}</span>
                        </button>
                    </div>
                </div>
            </div>

            <div class="inline-alert error" v-if="balanceError">
                <span>{{resources.giftcards.balanceError}}</span>
            </div>
            <div class="inline-alert error" v-if="limitError">
                <span>{{resources.giftcards.limitError}}</span>
            </div>
            <div class="inline-alert error" v-if="cardAlreadyInUseError">
                <span>{{resources.giftcards.cardAlreadyInUseError}}</span>
            </div>

            <vue-recaptcha v-if="resources.giftcards.recaptchaData.showRecaptcha"
                    ref="recaptcha"
                    @expired="resetCaptcha"
                    @verify ="handleRecaptchaSucess"
                    size="invisible"
                    :sitekey="resources.giftcards.recaptchaData.recaptchaSiteKey">
            </vue-recaptcha>

            <div class="button-row">
                <button type="button" class="giftcard-button btn" @click="submit('add')" :disabled="showSpinner">
                    <div :class="['spinner', 'white-spinner', { 'spinner-visible': showSpinner }]">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>

                    <template v-if="!showSpinner">
                        {{resources.giftcards.useThisCard}}
                    </template>
                </button>
                <button type="button" class="giftcard-button" @click="cancel">
                    <span class="giftcard-text">{{ resources.cancel }}</span>
                </button>
            </div>
            <vue-input hidden ref="captchaCallBack"></vue-input>
        </form>
    </div>
</template>

<script src='./giftcard.js'></script>
